export default __webpack_public_path__ + "static/media/Pepperoni-especial.baba8c9a.png";